import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { WhatsAppService } from '../../services/whatsapp.service'; // Import the WhatsAppService class
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormErrorHandler } from '../../../../modules/shared/helpers/form-error-handler.helper';
import { AppMainService } from '../../../../app-main.service';
@Component({
  selector: 'app-edit-flow',
  templateUrl: './edit-flow.component.html',
  styleUrls: ['./edit-flow.component.scss']
})
export class EditFlowComponent implements OnInit, OnChanges {
  @Input() display: boolean;
  @Input() selectedFlow:any;
  @Input() isViewOnly:boolean = false;
  flowForm: FormGroup;
  formErrorHandler: FormErrorHandler = new FormErrorHandler();
  detailsFormErrors: any = {};
  flowDetails:any;
  @Output() saveEditFlow = new EventEmitter();
  // formValidate:boolean = false;
  @Input() callFromChat:boolean = false;
  @Output() editFlowRequest = new EventEmitter();
  @Input() headerFlow:string;
  constructor(
    private whatsAppService: WhatsAppService,
    private formBuilder: FormBuilder,
    private appMainService: AppMainService,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.display &&  changes.display.currentValue){
      this.display = changes.display.currentValue;
    }

    if(changes.selectedFlow &&  changes.selectedFlow.currentValue){
      this.selectedFlow = changes.selectedFlow.currentValue;
      this.getFlowById(this.selectedFlow?.id);
    }

    if(changes.callFromChat &&  changes.callFromChat.currentValue){
      this.callFromChat = changes.callFromChat.currentValue;
    }

    if(changes.headerFlow &&  changes.headerFlow.currentValue){
      this.headerFlow = changes.headerFlow.currentValue;
    }

    if(changes.isViewOnly &&  changes.isViewOnly.currentValue){
      this.isViewOnly = changes.isViewOnly.currentValue;
      if (this.isViewOnly && this.flowForm) {
        this.viewFlowTemplate();
      }
    }
    // this.formValidate = false;
  }

  getFlowById(id){
    this.appMainService.isShowSpinner('getFlowById');
    this.whatsAppService.getFlowDetails(id).subscribe({
      next:(res)=>{
        this.flowDetails = res;
        this.initForm();
        this.appMainService.isHideSpinner('getFlowById');
        // console.log(res);
      },
      error:(err)=>{
        this.appMainService.isHideSpinner('getFlowById');
      }
    })
  }

  initForm() {
    this.flowForm = this.formBuilder.group({
      header: [this.flowDetails?.header||''],
      body: [this.flowDetails?.body||'',[Validators.required]],
      footer: [this.flowDetails?.footer||''],
      ctaText: [this.flowDetails?.ctaText||'',[Validators.required]],
    });
    this.formErrorHandler.handleErrors(this.flowForm, this.detailsFormErrors, {

      body: {
        required: `Enter Body`,
      },

      ctaText: {
        required: `Enter Call To Action`,
      },

    });
    if(this.isViewOnly){
      this.viewFlowTemplate();
    }

  }

  viewFlowTemplate(){
    this.flowForm.get('header').disable();
    this.flowForm.get('body').disable();
    this.flowForm.get('footer').disable();
    this.flowForm.get('ctaText').disable();
  }

  closeDialog(){
    this.saveEditFlow.emit();
  }

  submitForm(){
    if (this.flowForm.invalid) {
      this.flowForm.markAllAsTouched();
      this.flowForm.markAsDirty();
      this.formErrorHandler.showErrorOnSubmit();
      // this.formValidate = true;
      return;
    }
    // this.formValidate = false;
    let requestBody:any = {};
    if(this.flowDetails){
      requestBody = this.flowDetails;
    }
    requestBody.header = this.flowForm.value.header || null;
    requestBody.body = this.flowForm.value.body;
    requestBody.footer = this.flowForm.value.footer || null;
    requestBody.ctaText = this.flowForm.value.ctaText;
    if(this.callFromChat){
      this.editFlowRequest.emit(requestBody);
    }else{
      this.appMainService.isShowSpinner('updateFlow');
      this.whatsAppService.updateFlow(requestBody).subscribe({
        next:(res)=>{
          this.saveEditFlow.emit();
          this.appMainService.isHideSpinner('updateFlow');
        },
        error:(err)=>{
          this.appMainService.isHideSpinner('updateFlow');
        }
      })
    }
  }

}
